import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
// import reportWebVitals from "./reportWebVitals";
import * as axios from 'axios';
 
axios.defaults.baseURL = process.env.REACT_APP_API_URL;

const iframeFrom = process.env.REACT_APP_IFRAME_FROM;

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App iframeFrom={iframeFrom} />
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// FIXME: This should be turned on in development environment
// reportWebVitals();
